import axios from 'axios';
import * as Sentry from '@sentry/react';

export const createAttachment = attachment =>
	axios
		.post('/forms_rest_api/attachment', attachment)
		.then(({ data }) => data)
		.catch(error => {
			Sentry.captureException(error);
			throw error;
		});

export const deleteAttachment = (packetId, attachmentId) =>
	axios
		.get(`/forms_rest_api/delete_attachment/${packetId}?attachmentId=${attachmentId}`)
		.then(({ data }) => data)
		.catch(error => {
			Sentry.captureException(error);
			throw error;
		});

export const uploadAttachment = (file, image) =>
	axios
		.post(`/file/upload/node/attachment/field_image?_format=json`, image, {
			headers: {
				'Content-Type': 'application/octet-stream',
				'Content-Disposition': `file; filename="${file}"`,
				file
			}
		})
		.then(({ data }) =>
			axios
				.post(
					'/node?_format=json',
					{
						type: 'attachment',
						title: [{ value: file }],
						field_image: [{ target_id: data.fid[0].value }]
					},
					{
						headers: {
							Accept: 'application/json',
							'Content-Type': 'application/json'
						}
					}
				)
				.then(({ data: _data }) => _data)
		)
		.catch(error => {
			Sentry.captureException(error);
			throw error;
		});

export const addAttachment = async attachment => {
	if (attachment.attachment_type === 'photos') {
		const photo = await uploadAttachment(attachment.file, attachment.image);
		attachment = await createAttachment({
			attachment_nid: photo.nid[0].value,
			...attachment
		});
	} else {
		attachment = await createAttachment(attachment);
	}

	return {
		comment: attachment.attachment_comment,
		creator: attachment.attachment_creator,
		diver: attachment.attachment_diver,
		nid: attachment.attachment_nid,
		type: attachment.attachment_type,
		vid: attachment.attachment_vid,
		image: attachment.attachment_file ?? attachment.attachment_sketch?.[0]?.value,
		created: attachment.created * 1000,
		formId: attachment.form_id || '',
		formTitle: attachment.form_title || '',
		id: attachment.id
	};
};
